import { z } from "zod"

import { addUserSchema } from "./add-user.schema"

export const editUserSchema = addUserSchema.extend({
  organizationIds: z.array(z.string()),
})

export type EditUserSchema = z.infer<typeof editUserSchema>
